import React from 'react'
import './loader.scss'

export const DefaultLoader = () => (
    <div className="default-loader">
        <div className="rect1" />
        <div className="rect2" />
        <div className="rect3" />
        <div className="rect4" />
        <div className="rect5" />
    </div>
)
